module.exports = __webpack_public_path__ + "static/media/UdemyJava.40b14886.jpg";